import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('load', () => {
      this.element.classList.remove('opacity-0')
    })
  }
} 